import AppModel from '@/models/AppModel'
import store from '@/store/model-store'

const isDebug = process.env.NODE_ENV !== 'production'

export default {
  getApi: (bvModal, params = null, callbackFinally) => {
    return AppModel.get(
      'plan/images',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }

        AppModel.validateStatus(res.data)

        let modelStore = store.getters.model
        if (!modelStore) {
          modelStore = {}
        }

        modelStore['planimages'] = res.data
        store.commit('setModel', modelStore)

        return Promise.resolve(res.data)
      },
      null, callbackFinally
    )
  },
  postApi: (bvModal, params, callbackFinally) => {
    return AppModel.post(
      'plan/images',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }
        AppModel.validateStatus(res.data)

        return Promise.resolve(res.data)
      },
      callbackFinally
    )
  },
  putApi: (bvModal, params, callbackFinally) => {
    return AppModel.put(
      'plan/images',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }
        AppModel.validateStatus(res.data)

        return Promise.resolve(res.data)
      },
      callbackFinally
    )
  },
  deleteApi: (bvModal, params = null, callbackFinally) => {
    return AppModel.delete(
      'plan/images',
      bvModal,
      params,
      (res) => {
        if (isDebug) {
          console.log(res.data)
        }
        AppModel.validateStatus(res.data)

        return Promise.resolve(res.data)
      },
      callbackFinally
    )
  },
  getStore: (key) => {
    return AppModel.getStore('planimages', key)
  },
  removeStore: () => {
    delete store.getters.model.agenda
  }
}



// WEBPACK FOOTER //
// ./src/models/PlanImageModel.js